import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

// Animates its height so stepping through the survey doesn't jump.
// placement: "modal" (centered, backdrop), "corner" (bottom right) or "page" (inline).
export default function SurveyFrame({ children, closable, fadingOut, onClose, placement, step }) {
  const contentRef = useRef(null);
  const [height, setHeight] = useState(null);

  useLayoutEffect(() => {
    if(contentRef.current) {
      setHeight(contentRef.current.offsetHeight);
    }
  }, [step, children]);

  useEffect(() => {
    if(!contentRef.current || typeof ResizeObserver === "undefined") {
      return undefined;
    }
    const observer = new ResizeObserver(() => setHeight(contentRef.current.offsetHeight));
    observer.observe(contentRef.current);
    return () => observer.disconnect();
  }, []);

  const frame = (
    <div className={`survey survey-${placement}${fadingOut ? " fading-out" : ""}`}>
      {placement === "modal" && <div className="survey-backdrop" />}
      <div className="survey-card" role="dialog" aria-modal={placement === "modal"}>
        {closable && (
          <button
            aria-label="Close"
            className="survey-close"
            onClick={onClose}
            type="button"
          >
            &times;
          </button>
        )}
        <div className="survey-sizer" style={height == null ? null : { height }}>
          <div ref={contentRef}>
            <div className="survey-fade" key={step}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  if(placement === "page") {
    return frame;
  }
  return ReactDOM.createPortal(frame, document.querySelector("body"));
}
